/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TestMcpServerRequest = {
  serverId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const TestMcpServerRequest$inboundSchema: z.ZodType<
  TestMcpServerRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  server_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "server_id": "serverId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type TestMcpServerRequest$Outbound = {
  server_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const TestMcpServerRequest$outboundSchema: z.ZodType<
  TestMcpServerRequest$Outbound,
  z.ZodTypeDef,
  TestMcpServerRequest
> = z.object({
  serverId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    serverId: "server_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function testMcpServerRequestToJSON(
  testMcpServerRequest: TestMcpServerRequest,
): string {
  return JSON.stringify(
    TestMcpServerRequest$outboundSchema.parse(testMcpServerRequest),
  );
}
export function testMcpServerRequestFromJSON(
  jsonString: string,
): SafeParseResult<TestMcpServerRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TestMcpServerRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TestMcpServerRequest' from JSON`,
  );
}
